import type {
  BlockRendererMapping,
  BlockValues,
} from "@circle-react-shared/BuilderUI/BuilderUI.types";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { isChildrenProp } from "@circle-react-shared/BuilderUI/Helpers/typePredicates";
import { useDeviceContext } from "../DeviceProvider";
import { isNonNullableUnknown } from "../Helpers/typePredicates";
import { flattenResponsiveStylesDeep } from "../Preview/flattenResponsiveStylesDeep";
import { RenderBlockList } from "./RenderBlockList";

export interface RendererProps {
  block: BaseBlock;
  components: BlockRendererMapping;
}

export const Renderer = ({ block, components }: RendererProps) => {
  const Component = components[block.type];
  const device = useDeviceContext();

  if (!Component) return null;

  const initialProps: BlockValues = {
    key: block.id,
  };

  const entries = Object.entries(block.props);

  const props = entries.reduce((props, [name, prop]) => {
    if (isChildrenProp(prop)) {
      props[name] = (
        <RenderBlockList blocks={prop.value} components={components} />
      );
    } else if (isNonNullableUnknown(prop.value)) {
      if (name === "styles") {
        props[name] = flattenResponsiveStylesDeep(prop.value, device);
      } else {
        props[name] = prop.value;
      }
    }
    return props;
  }, initialProps);

  return <Component data-block data-block-type={block.type} {...props} />;
};
